// IMPORTANT:
// Currently DSE needs no LAYA API backend.
// For video URLs the same AWS S3 bucket is used as for the DSE webapp (see awsURL.js)
export default function () {
  return /localhost/.test(location.host)
    ? 'https://CURRENTLY-NO-LAYA-BACKEND-IS-USED-FOR-DSE'
    : 'https://CURRENTLY-NO-LAYA-BACKEND-IS-USED-FOR-DSE'
}



// WEBPACK FOOTER //
// ./src/backendURL.js